/**
 * Champs client utilisés sur le BDC PDF.
 */
export const EMPTY_PLAN_DE_COM_CLIENT_FORM = {
  entreprise_label: '',
  client_label: '',
  dolibarr_thirdparty_id: null,
  client_adresse: '',
  client_cp: '',
  client_ville: '',
  client_telephone: '',
  client_email: '',
};

export function mapDossierToClientForm(dossier) {
  if (!dossier) return { ...EMPTY_PLAN_DE_COM_CLIENT_FORM };
  return {
    entreprise_label: dossier.entreprise_label ?? '',
    client_label: dossier.client_label ?? '',
    dolibarr_thirdparty_id: dossier.dolibarr_thirdparty_id ?? null,
    client_adresse: dossier.client_adresse ?? '',
    client_cp: dossier.client_cp ?? '',
    client_ville: dossier.client_ville ?? '',
    client_telephone: dossier.client_telephone ?? '',
    client_email: dossier.client_email ?? '',
  };
}

export function clientFormToSavePayload(form) {
  return {
    entreprise_label: form.entreprise_label || null,
    client_label: form.client_label || null,
    dolibarr_thirdparty_id: form.dolibarr_thirdparty_id ?? null,
    client_adresse: form.client_adresse || null,
    client_cp: form.client_cp || null,
    client_ville: form.client_ville || null,
    client_telephone: form.client_telephone || null,
    client_email: form.client_email || null,
  };
}

/**
 * Complète les champs vides avec la fiche Dolibarr (sans écraser une saisie existante).
 */
export function mergeDolibarrClientIntoForm(form, client) {
  if (!client) return form;
  const companyName = String(client.nom ?? '').trim();
  const contactName = String(client.client_label ?? '').trim();

  return {
    ...form,
    entreprise_label: form.entreprise_label || companyName,
    client_label: form.client_label || contactName,
    client_adresse: form.client_adresse || client.adresse || '',
    client_cp: form.client_cp || client.cp || '',
    client_ville: form.client_ville || client.ville || '',
    client_telephone: form.client_telephone || client.telephone || '',
    client_email: form.client_email || client.email || '',
    dolibarr_thirdparty_id: form.dolibarr_thirdparty_id ?? client.id ?? null,
  };
}

/**
 * Patch dossier à partir d'une fiche Dolibarr (pour préremplir avant ouverture du modal).
 */
export function dolibarrClientToDossierPatch(client, dossier = {}) {
  const companyName = String(client?.nom ?? dossier.entreprise_label ?? '').trim();
  const contactName = String(client?.client_label ?? '').trim();

  return {
    entreprise_label: companyName || dossier.entreprise_label || null,
    client_label: contactName || dossier.client_label || null,
    dolibarr_thirdparty_id: client?.id ?? dossier.dolibarr_thirdparty_id ?? null,
    client_adresse: client?.adresse || dossier.client_adresse || null,
    client_cp: client?.cp || dossier.client_cp || null,
    client_ville: client?.ville || dossier.client_ville || null,
    client_telephone: client?.telephone || dossier.client_telephone || null,
    client_email: client?.email || dossier.client_email || null,
  };
}

/**
 * Infos manquantes avant génération BDC (coordonnées affichées sur le PDF).
 * @returns {string[]}
 */
export function getMissingBdcClientFields(source) {
  const form = {
    entreprise_label: source?.entreprise_label ?? '',
    client_adresse: source?.client_adresse ?? '',
    client_cp: source?.client_cp ?? '',
    client_ville: source?.client_ville ?? '',
  };

  const missing = [];
  if (!String(form.entreprise_label).trim()) missing.push('entreprise_label');
  if (!String(form.client_adresse).trim()) missing.push('client_adresse');
  if (!String(form.client_cp).trim()) missing.push('client_cp');
  if (!String(form.client_ville).trim()) missing.push('client_ville');
  return missing;
}

export function needsBdcClientInfoModal(source) {
  return getMissingBdcClientFields(source).length > 0;
}
